import { currentThemeName } from './theme.store';

export const setTheme = (theme) => {
  currentThemeName.update(() => theme);
};
